.container {
  width: 100%;
}

.results {
  width: 100%;
  max-height: 250px;
  overflow-y: auto;
}

.bulk-actions {
  margin-top: 8px;
  display: flex;
  justify-content: flex-end;
}

.result {
  display: flex;
  justify-content: space-between;
}

.descriptor {
  width: 80%;
  text-overflow: ellipsis;
}

.actions {
  display: flex;
  flex-direction: row-reverse;
  gap: 8px;
}

.action-control {
  padding: 0;
  cursor: pointer;
}

.result > .actions > .action-control{
  visibility: hidden;
}

.result:hover > .actions > .action-control{
  visibility: visible;
}
